import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

const MidSection = () => {

  const [lang, setLang] = useState(localStorage.getItem('lang') || 'en');

  useEffect(() => {
    const handleStorageChange = () => {
      setLang(localStorage.getItem('lang') || 'en');
    };
    
    window.addEventListener('storage', handleStorageChange);
    const interval = setInterval(handleStorageChange, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  const content = {
    en: {
      badge: "CLOSING CTA",
      title: "Let's start a conversation",
      suffix: "No pressure, no obligation. Just an honest discussion about where you are, what you need, and how we can help. We think you will find it worthwhile.",
      btnText: "Request a Consultation"
    },
    zh: {
      badge: "开启对话",
      title: "让我们开始 一次交流",
      suffix: "无需压力，无需义务。只是一场坦诚的交流，了解您的现状、需求以及我们如何提供帮助。我们相信，这将是一次值得的沟通。",
      btnText: "预约咨询"
    }
  };

  const current = content[lang];

  return (
    <section className="relative py-12 md:py-12 bg-white">

      <div className="px-6 mx-auto max-w-6xl">

        {/* CREAM BOX */}
        <div className="bg-[#F5F0E8] p-8 md:p-12 lg:p-16  shadow-sm">

          <div className="flex flex-col gap-10 md:flex-row md:items-center md:justify-between">

            {/* LEFT */}
            <div className="w-full md:w-2/3">

              {/* BADGE */}
              <span className="text-[#B08D57] uppercase tracking-[0.35em] text-[11px] mb-4 block font-arial">
                {current.badge}
              </span>

              {/* TITLE */}
              <h2 className="text-[28px] md:text-[34px]  text-[#1A1A1A] leading-tight  font-century mb-4">
                {current.title}
              </h2>

              {/* TEXT */}
              <p className="text-[14px] md:text-[16px] text-[#666666] max-w-xl leading-relaxed">
                {current.suffix}
              </p>

            </div>

            {/* RIGHT CTA */}
            <div className="flex md:justify-end md:w-1/3">

              <Link 
                to="/contact"
                className="text-[#1A1A1A] text-[14px] font-semibold tracking-wide group flex items-center gap-2 hover:text-[#B08D57] transition"
              >
                {current.btnText}
                <span className="transition-transform duration-300 group-hover:translate-x-1">
                  →
                </span>
              </Link>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default MidSection;